<template>
    <div class="recharge_order-container">
        <order-list :order-type="1"></order-list>
    </div>
</template>

<script>
    import OrderList from './OrderList'

    export default {
        name: 'ConsumeOrder',
        components: {OrderList},
        data () {
            return {}
        },
        mounted () {},
        methods: {}
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/order/ConsumeOrder.vue